export const IPSDetailTemplateHeaders = [
    { label: "No", key: "No" },
    { label: "Cluster Center", key: "clusterCenter" },
    { label: "Site", key: "Site" },
    { label: "Asset Number", key: "assetNumber" },
    { label: "Asset Category", key: "assetCategory" },
    { label: "Asset Description", key: "assetDescription" },
    { label: "Asset Location", key: "assetLocation" },
    { label: "Manufacturer", key: "manufacturer" },
    { label: "Model", key: "model" },
    { label: "Serial No", key: "serialNo" },
    { label: "Frequency", key: "frequency" },
    { label: "PM Schedule Description", key: "pmScheduleDescription" },
    { label: "PM Schedule Code", key: "pmScheduleCode" },
    { label: "Due Date", key: "dueDate" },
    { label: "Compliance Start Date", key: "Compliance" },
    { label: "Compliance End Date", key: "Compliance" },
    { label: "Qty", key: "qty" },
    { label: "Unit Of Measure", key: "unitOfMeasure" },
    { label: "Unit Price", key: "unitPrice" },
    { label: "Total", key: "total" },
    { label: "Currency", key: "currency" },
    { label: "Supplier OFA ID", key: "supplierOfaId" }
];

export const IPSDetailHeaderListForProcessing = IPSDetailTemplateHeaders.map(header => {
    return header.key;
});

export const IPSDetailBuyerProhibitedColumns = [
    'unitPrice',
    'total'
];

export const IPSDetailSupplierProhibitedColumns = IPSDetailTemplateHeaders.map(header => {
    if (!IPSDetailBuyerProhibitedColumns.includes(header.key)) {
        return header.key
    }
    return '';
});

export const IPSDetailHeaderListForCSV = IPSDetailTemplateHeaders.map(header => {
    return header.label;
}).join() + '\n';